import { RESPONSE_TYPES } from "@root/constants";
import { HttpService } from "@services/http";
import {
  prepareErrorResponse,
  prepareResponseObject,
} from "@services/http/response";

export class NoticeService extends HttpService {
  getNotices = async (
    baseAuthUrl: string,
    params: any = {}
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const queryParams: string[] = [];
      if (params.search) {
        queryParams.push(`search=${encodeURIComponent(params.search)}`);
      }
      if (params.limit) {
        queryParams.push(`limit=${params.limit}`);
      }
      if (params.offset !== undefined) {
        queryParams.push(`offset=${params.offset}`);
      }
      const query = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
      const apiResponse = await this.get(`${baseAuthUrl}/api/notice${query}`, {
        slug: params.slug ?? "",
      });
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  getPublishNotices = async (
    baseAuthUrl: string,
    params: any = {}
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const queryParams: string[] = [];
      if (params.search) {
        queryParams.push(`search=${encodeURIComponent(params.search)}`);
      }
      if (params.limit) {
        queryParams.push(`limit=${params.limit}`);
      }
      if (params.offset !== undefined) {
        queryParams.push(`offset=${params.offset}`);
      }

      if (params.noticeTypeId) {
        queryParams.push(`noticeTypeId=${params.noticeTypeId}`);
      }
      const query = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
      const apiResponse = await this.get(
        `${baseAuthUrl}/api/notice/published${query}`,
        {
          slug: params.slug ?? "",
        }
      );
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  deleteNotice = async (
    baseAuthUrl: string,
    id: string
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.delete(
        `${baseAuthUrl}/api/notice/${id}`,
        undefined
      );
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  updateNotice = async (
    baseAuthUrl: string,
    payload: any,
    id: number
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.patch(
        `${baseAuthUrl}/api/notice/${id}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  addNotice = async (
    baseAuthUrl: string,
    data: Record<string, TObject>
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.post(`${baseAuthUrl}/api/notice`, data, {
        headers: {
          "Content-Type": "multipart/form-data", // Important for file uploads
        },
      });
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  pinNotice = async (
    baseAuthUrl: string,
    id: number,
    pin: boolean
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.patch(
        `${baseAuthUrl}/api/notice/${id}/pin`,
        { pin }
      );
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };

  downloadDocumentsZip = async (
    baseAuthUrl: string,
    documentIds: number[],
    noticeId?: number
  ): Promise<any> => {
    try {
      const queryParams: string[] = [];
      queryParams.push(`documentIds=${documentIds.join(",")}`);
      if (noticeId) {
        queryParams.push(`noticeId=${noticeId}`);
      }
      const query = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

      const apiResponse = await this.get(
        `${baseAuthUrl}/api/documents/download-zip${query}`,
        null,
        { responseType: "blob" }
      );
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
